export default __webpack_public_path__ + "static/media/paperFoldedLarge.17bc96bc.jpg";